import excuseApi from '../api/excuseApi';

const ArticleModel = {
  id: null,
  category_id: null,
  timeline_id: null,
  thumbnail: '',
  title: '',
  description: '',
  content: '',
  created_at: '',
  category_name: '',
  timeline_name: '',
  type: '',
};

// 🟢 Thêm bài viết
export const createArticle = (formData) =>
  excuseApi({
    endpoint: '/articles',
    method: 'POST',
    data: formData,
  });

// 🟢 Cập nhật bài viết
export const updateArticle = (id, formData) =>
  excuseApi({
    endpoint: `/articles/${id}`,
    method: 'PUT',
    data: formData,
  });

// 🔴 Xoá bài viết
export const deleteArticle = (id) =>
  excuseApi({
    endpoint: `/articles/${id}`,
    method: 'DELETE',
  });

// 🟢 Lấy tất cả bài viết
export const getAllArticles = () =>
  excuseApi({
    endpoint: '/articles',
    method: 'GET',
  });

// 🟢 Lấy bài viết theo ID
export const getArticleById = (id) =>
  excuseApi({
    endpoint: `/articles/${id}`,
    method: 'GET',
  });

// 🟢 Lọc + phân trang bài viết
export const filterArticles = ({
  page = 1,
  limit = 12,
  category_id,
  timeline_id,
  sort = 'asc',
  title,
  type
}) => {
  const params = new URLSearchParams();

  params.append('page', page);
  params.append('limit', limit);
  params.append('sort', sort);
  if (category_id) params.append('category_id', category_id);
  if (timeline_id) params.append('timeline_id', timeline_id);
  if (title) params.append('title', title);
  if (type) params.append('type', type);

  return excuseApi({
    endpoint: `/articles/filter?${params.toString()}`,
    method: 'GET',
  });
};

const Article = {
  filterArticles,
};

export default ArticleModel;
